module.exports = __webpack_public_path__ + "static/netlify-95e178f5b1dc1a2327595784442a866c.png";